import { jsx as _jsx } from "react/jsx-runtime";
import { List, ListItem, ListItemText } from "@mui/material";
export const DemoItemsList = (props) => {
    return (_jsx(List, { children: props.items.map((itemName, index) => _jsx(ListItem, { children: _jsx(ListItemText, { children: itemName }) }, index)) }));
};
export const demoItems = ["Aaron", "Abbi", "Audrey", "Camille", "Carlos", "Elena", "Gabriel", "Jean", "Karla", "Laura", "Marco", "Margot", "Maria", "Pablo", "Sofia", "Terra", "wade"];
//# sourceMappingURL=DemoItemsList.js.map